export default __webpack_public_path__ + "static/media/about.cc0ac2ca.png";